<template>
    <div class="answer-list-content answer-list-main-symptom">

        <!-- ----------------------------------------- -->
        <!-- CHAPTER TREE / SEARCH MAIN SYMPTOM -->
        <!-- ----------------------------------------- -->

        <div v-if="getChapterTree && getCurrentAssessmentStatus === getAssessmentStatuses.CHAPTER_TREE" class="choose-main-symptom-container">

            <!-- The button that opens the "Choose Main Symptom" popup -->
            <div class="main-symptom-search-input-container" :class="{'is-search-mode': isSearchModeActive}">

                <v-btn v-if="getCurrentAssessmentStatus === getAssessmentStatuses.CHAPTER_TREE"
                       @click="openSearchDialog(), browserDetect()"
                       id="btnSearchSymptomDialog"
                       block
                       class="btn-search-symptom-dialog">
                    {{text("api.chatbot.btn.searchMainSymptom")}}
                </v-btn>

            </div>

        </div>

        <choose-main-symptom-popup v-if="getChapterTree"></choose-main-symptom-popup>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import Vue from "vue";
    import ChooseMainSymptomPopup from "./main-symptom-popup/ChooseMainSymptomPopup";

    export default {
        name: 'AnswerListMainSymptom',
        components: {
            ChooseMainSymptomPopup
        },

        data() {
            return {

                // Tells if the user is currently searching for main symptom instead of browsing chapters/subchapters.
                // When this is true, search results (or "no results" message) will be displayed instead of chapter/subchapter list.
                isSearchModeActive: false,
                isConfirmBtnClickDisabled: false, // This will help us to prevent multiple clicks on Confirm button.,

                confirmButtonIESafari: false,

                mainSymptomCode: null,

                radioButtonPlugin: Vue.RadioButton.RadioButtonSvg,
                searchRedPfPlugin: Vue.SearchRedPf.searchRedPfSvg,
            }
        },

        computed: {
            ...mapGetters({
                getChapterTree: 'ChatBotStore/getChapterTree',
                getMustShowChooseMainSymptomPopup: 'ChatBotStore/getMustShowChooseMainSymptomPopup',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getLoadApp: 'TranslationStore/getLoadApp',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),

            searchSymptomInputValue: {
                get () {
                    return this.$store.state["ChatBotStore"].searchSymptomInputValue;
                },
                set (newValue) {
                    this.$store.commit('ChatBotStore/setSearchSymptomInputValue', newValue);

                    if (newValue !== null && newValue.length > 0) {
                        this.closeChapter();
                        this.$store.dispatch('ChatBotStore/submitSearchMainSymptom');
                    }
                    else {
                        this.$store.commit('ChatBotStore/clearSearchSymptomResultList');
                    }
                    this.$store.commit("ChatBotStore/setMustShowChooseMainSymptomPopup", true);
                    let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
                    rootElement.classList.add('hide-scroll');
                }
            }
        },

        mounted() {

            window.addEventListener('resize', () => {
                document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
            });

        },

        watch: {

            getMustShowChooseMainSymptomPopup(newVal, oldVal){
                if (newVal === true) {

                    // ------- On popup OPEN. -------

                    let that = this;
                    setTimeout(() => {
                        // Scroll to already selected symptom (edit mode).
                        let providedAnswerElem_mainSymptom = document.querySelector('.dialog.popup-symptoms .input-group--active');

                        if (providedAnswerElem_mainSymptom) {
                            providedAnswerElem_mainSymptom.scrollIntoView();
                            let radio = providedAnswerElem_mainSymptom.getElementsByClassName('icon--radio');
                            if (radio && radio.length > 0) {
                                radio[0].innerHTML = that.radioButtonPlugin();
                            }
                        }
                    }, 100);
                    let searchIcon = document.querySelector('.search-main-symptom-pf');
                    if (searchIcon !== null) {
                        searchIcon.innerHTML = this.searchRedPfPlugin();
                    }

                    // Add a specific class to <html> tag, so we know that the Main Symptom popup is open even
                    // outside of the popup. For example, this will allow us to hide the transparent overlay when page
                    // width is greater than 600px. This class must be removed when "Main Symptom" popup is closed.
                    document.querySelector('html').classList.add('is-main-symptom-popup-open');

                }
                else {

                    // ------- On popup CLOSE. -------

                    document.querySelector('html').classList.remove('is-main-symptom-popup-open');
                }
            },

            getChapterTree(newVal, oldVal){

                //TODO RO: Check this more !
                if (this.getCurrentAssessmentStatus === this.getAssessmentStatuses.CHAPTER_TREE  /* && oldVal === null */ && newVal !== null) {
                    this.isConfirmBtnClickDisabled = false; // We have a new chapter tree, so we make sure that clicks are enabled.

                    this.$nextTick(function () {
                        this.$emit('onAnswerListUpdated');
                    });
                }
                if (newVal && this.getLoadApp) {
                    this.mainSymptomCode = this.getChapterTree.mainSymptomCode;
                }

            },

        },

        methods: {

            openSearchDialog() {
                this.$store.commit("ChatBotStore/setMustShowChooseMainSymptomPopup", true);
                let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
                rootElement.classList.add('hide-scroll');
            },


            browserDetect() {

                if((navigator.userAgent.indexOf("Safari") != -1) || (navigator.userAgent.indexOf("MSIE") != -1 )) {
                    this.confirmButtonIESafari = true;
                }

            },

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .choose-main-symptom-container {
        display: flex;
        flex-direction: column;
        overflow: visible;
        clear: both;
        max-width: 600px;
        width: 100%;
        height: auto;
        overflow-x: hidden;
    }

    .answer-item {
        display: inline-block;
        border: 1px solid #d3d5d9;
        border-radius: 20px;
        padding: 10px 20px;
        color: #a43a45;
        cursor: pointer;
        margin-right: 15px;
        margin-bottom: 10px;
    }

    .chapter-list-container {
        overflow-y: hidden;
        position: relative;
        width: 99%;
        padding-left: 6px;
        padding-right: 6px !important;
        margin-left: 6px;
        overflow-x: hidden;
    }
    .chapter-list {
        margin-top: 10px;
        flex-direction: column;
        flex-wrap: wrap;
        height: auto;
    }

    .chapter-item {
        min-height: 140px;
        padding: 6px 6px 6px 0 !important;
    }
    .chapter-item-content {
        height: 100%;
        display: block;
        padding: 20px 8px 8px 5px;
        /*border: 1px solid #d2d3d4;*/
        box-shadow: 0px 3px 10px 3px #e0e2e4;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
        word-break: break-word;

        button {
            padding: 0 20px;
        }
    }

    .subchapter-name {
        // SMASSDEV - 1119
        font-size: $font-size-medium;
        // word-spacing: $word-spacing-medium;
        // line-height: $line-height-medium;
        // letter-spacing: $letter-spacing-medium;
        color: $color-headings-text;
    }

    .symptom-name {
        color: #737b7f;
        // SMASSDEV - 1119
        font-size: $font-size-small;
        // word-spacing: $word-spacing-small;
        // line-height: $line-height-small;
        // letter-spacing: $letter-spacing-small;
        word-break: break-word;
    }

    .popup-subchapters-symptoms-title {
        font-weight: $font-weight-light;
        margin-left: 20px;
    }

    // Symptoms search results.

    .main-symptom-search-results {

        ul.list {
            overflow-y: auto;
            overflow-x: hidden;

            li {
                margin-top: 10px;
                margin-bottom: 10px;

                &:last-of-type {
                    margin-bottom: 0 !important;
                }
            }
        }

        .symptom-name {
            font-size: $font-size-default;
        }

        .symptom-synonyms {
            // SMASSDEV - 1119
            font-size: $font-size-extra-small;
            // word-spacing: $word-spacing-extra-small;
            // line-height: $line-height-extra-small;
            // letter-spacing: $letter-spacing-extra-small;;
        }

        .match {
            color: #515b60;
        }

        .info-no-results {
            font-style: italic;
            margin-top: 30px;
        }
    }

    .main-symptom-search-input-container {
        width: auto;
        text-align: center;
    }

    // @TODO This may need to be moved to a global CSS code, it doesn't seem to work here, maybe because of inherited components (this selector is querying for a child component element???).
    .main-symptom-search-input-container .input-group__input .input-group__prepend-icon {
        background-color: deeppink; //@TODO To be removed, this is for tests purpose only.
        min-width: 36px;
        border-radius: 50%;
        margin-right: 16px;
        height: 36px;
        box-shadow: 0px 0px 10px 1px #d4d6d7;
    }
    .main-symptom-search-input-container.is-search-mode .input-group__input .input-group__prepend-icon {
        box-shadow: none;
    }

    .btn-search-symptom-dialog {
        -webkit-box-shadow: 0px 3px 10px 3px #e0e2e4;
        box-shadow: 0px 3px 10px 3px #e0e2e4;
        border-radius: 10px;
        text-align: left;
      //  background-color: $color-lightest;
    }


    .confirm-selected-main-symptom {
        text-align: center;
        margin: 0 !important;
        width: 100%;
        padding: 0 20px;
        background-color: #ffffff50;

        .btn {
            border-radius: 20px;
            padding: 0 !important;
            margin: 0 !important;
        }
    }

    .btn-subchapter-symptom {
        text-align: center;

        .btn {
            border-radius: 20px;
        }
    }

    @media only screen and (min-width: 301px) and (max-width: 1028px) {

        ::-webkit-scrollbar {
            -webkit-appearance: none;
        }

        ::-webkit-scrollbar:vertical {
            width: 12px;
        }

        ::-webkit-scrollbar:horizontal {
            height: 12px;
        }

        ::-webkit-scrollbar-thumb {
            background-color: $color-gray;
            border-radius: 10px;
            border: 2px solid #ffffff;
        }

        ::-webkit-scrollbar-track {
            border-radius: 10px;
            background-color: #ffffff;
        }

    }

    .card.popup-subchapters-symptoms-wrapper .list > li:hover .list__tile.list__tile.list__tile--link .list__tile__title .symptom-name{
        color: $color-headings-text;
    }

    li.list-no-subchapters {
        list-style: none;
        border-bottom: 1px solid $color-gray-lightest;
    }

    .btn-search-symptom-dialog.btn .icon {
        color: $color-brand-primary;
    }

    @media only screen and (max-width: 599px) {
        .main-symptom-search-input-container{
            margin: 20px 0 12px 0;
        }
    }
    @media only screen and (min-width: 600px) {
        .main-symptom-search-input-container {
            margin: 36px 0 24px 0;
        }
    }

    .popup-subchapters-symptoms {

        .card__actions {
            margin: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListMainSymptom.vue